import { keepPreviousData, useQuery } from "@tanstack/react-query";
import PaginationURL from "util/PaginationURL";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const DEFAULT_DATA = {
  pagination: {
    total: 0
  },
  suggestions: []
};
const fetchFilterValueSuggestions = async (collection, { query, page, pageSize }, collectionProperty = "title") => {
  const additional = {
    collection,
    column: collectionProperty
  };
  const url = PaginationURL("entity_suggestions", page, pageSize, query, additional);
  return fetch("GET", qualifyUrl(url));
};
const useFilterValueSuggestions = (attributeId, collection, searchParams, collectionProperty) => {
  if (!collection) {
    throw Error(`Attribute meta data for attribute "${attributeId}" is missing related collection.`);
  }
  const { data, isInitialLoading } = useQuery({
    queryKey: ["filters", "suggestions", searchParams],
    queryFn: () => defaultOnError(
      fetchFilterValueSuggestions(collection, searchParams, collectionProperty),
      "Loading suggestions for filter failed with status",
      "Could not load filter suggestions"
    ),
    retry: 0,
    placeholderData: keepPreviousData
  });
  return {
    data: data != null ? data : DEFAULT_DATA,
    isInitialLoading
  };
};
export default useFilterValueSuggestions;
